// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"9636":"wix-i18n-config_intl-relativetimeformat","9753":"wix-i18n-config_intl-pluralrules"}[chunkId] || chunkId) + ".chunk.min.js";
};